export const navigation = {
  'Go back': 'Indietro',
  'Go forward': 'Avanti',
};
